export default __webpack_public_path__ + "static/media/pic1.60ba144e.jpg";